<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <b-col md="12">
            <b-row>
                <b-col md="3">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Month"
                                :clearable="false"
                                :filterable="false"  
                                fullContent
                                :searchable="false"
                                :options="months"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="month">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Year"
                                :clearable="false"
                                :filterable="false" 
                                :searchable="false"
                                :options="years"
                                v-model="year">
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="7">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Supplier Contract"
                                vLabel="contract_title"
                                @search="searchSupplierContract"
                                :filterable="false"
                                v-model="supplier_contract"
                                :options="supplier_contracts">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="5">
                            <gofix-form-dropdown 
                                label="Property Type" 
                                :filterable="false" 
                                :options="property_types" 
                                v-model="property_type"
                                :clearable="false"
                                required 
                                show-icon-required>
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="5">
                    <b-row>
                        <b-col md="8">
                            <gofix-form-dropdown
                                v-bind:class="{'run-loading small-loading': loading}"
                                label="Division" 
                                :filterable="false" 
                                :options="locations" 
                                v-model="location" 
                                @search="searchLocation" 
                                vLabel="name"
                                show-icon-required>
                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                    <span class="text-hidden-one-row">{{ option.location_path || '-' }}</span>
                                </template>
                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                    <span v-b-tooltip.hover.top :title="option.location_path" v-html="$options.filters.highlightNode(option.location_path, key_search_property)"></span>
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="4" class="text-center">
                            <gofix-button class="mb-2 mx-2" label="Export PDF" @click="exportReport()" :disabled="activeExportBtn == false"></gofix-button>
                            <gofix-button label="Export Excel" @click="exportExcel()" :disabled="activeExportBtn == false"></gofix-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <hr/>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:weightage" slot-scope="row">
                {{ `${row.item.weightage}%` }}
            </template>
            <template slot="gofix_table:actual_score" slot-scope="row">
                {{ `${row.item.actual_score}%` }}
            </template>
            <template slot="gofix_table:bottom-row" slot-scope="row" v-if="tableItems.length">
                <td class="text-right" :class="{'align-top': field.key === 'weightage'}" :key="i" v-for="(field, i) in row.data.fields">
                    <div class="total-header mt-3" v-if="field.key === 'assessment_type'">
                        <p class="mb-2 text-left">
                            <strong>Total</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>Adjustment</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>Final Score</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>% Deduction in Payment</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>% Payment to Contractor</strong>
                        </p>
                        <!-- <p class="mb-2 text-left">
                            <strong>Less rates of deduction</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>Payment to Contractor ($)</strong>
                        </p> -->
                        <p class="mb-2 text-left">
                            <strong>Contract Sum</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>GST {{ tableFooter.gst }}%</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>Contract Sum After GST</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>CV Assessment LD</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>Additional LD (Rates of Deduction)</strong>
                        </p>
                        <p class="mb-2 text-left">
                            <strong>Final Payment to Contractor ($)</strong>
                        </p>
                    </div>
                    <div class="mt-3" v-if="field.key === 'weightage'">
                        <p class="mb-2"><strong>{{ tableFooter.total_weight }}%</strong></p>
                        <p class="mb-2"></p>
                        <p class="mb-2"></p>
                        <p class="mb-2"></p>
                        <p class="mb-2"></p>
                        <p class="mb-2"></p>
                        <p class="mb-2"></p>
                    </div>
                    <div class="mt-3" v-if="field.key === 'actual_score'">
                        <p class="mb-2"><strong>{{ tableFooter.total_actual_score }}%</strong></p>
                        <p class="mb-2"><strong>{{ `${tableFooter.adjust}%` }}</strong></p>
                        <p class="mb-2"><strong>{{ (tableFooter.total_actual_score + tableFooter.adjust).toFixed(2) }}%</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.deduction }}%</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.percent_payment_to_contractor }}%</strong></p>
                        <!-- <p class="mb-2"><strong>{{ tableFooter.less_rates_of_deduction | formatMoney }}</strong></p> -->
                        <p class="mb-2"><strong>{{ tableFooter.contract_sum | formatMoney }}</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.payment_to_gst | formatMoney }}</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.contract_sum_after_gst | formatMoney }}</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.cv_assessment_ld | formatMoney }}</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.less_rates_of_deduction | formatMoney }}</strong></p>
                        <p class="mb-2"><strong>{{ tableFooter.final_payment_to_contractor | formatMoney }}</strong></p>
                    </div>
                    <div class="mt-3" v-if="field.key === 'auto'">
                        <p class="mb-2" style="opacity: 0;">0</p>
                        <p class="mb-2" style="opacity: 0;">0</p>
                        <p class="mb-2 text-left">
                            <gofix-button label="Adjust score" @click="openModalEdit"></gofix-button>
                        </p>
                        <p class="mb-2" style="opacity: 0;">0</p>
                        <p class="mb-2" style="opacity: 0;">0</p>
                        <p class="mb-2" style="opacity: 0;">0</p>
                        <p class="mb-2" style="opacity: 0;">0</p>
                    </div>
                </td>
            </template>
        </gofix-table>
        <b-modal
                :no-close-on-backdrop="true"
                id="modal-Create"
                :title="modalsAdjust.edit.title"
                hide-footer
                :centered="true"
                v-model="modalsAdjust.edit.open">
            <div>
                <b-form>
                    <b-row>
                        <b-col md="12">
                            <p>Please enter the final score</p>
                            <gofix-form-input-number
                                label="Final Score"
                                thousandsSeparatorSymbol=""
                                :includeThousandsSeparator="false"
                                v-model="modalsAdjust.edit.data.final_score"
                                allowNegative
                            />
                            <gofix-form-input-number
                                label="Adjustment"
                                thousandsSeparatorSymbol=""
                                :includeThousandsSeparator="false"
                                v-model="modalsAdjust.edit.data.adjust"
                                :disabled="true"
                                allowNegative
                            />
                            <span v-if="tableFooter.pa_adjust">
                                Last modified by 
                                <strong>{{ this.tableFooter.pa_adjust.user_name }}</strong> at 
                                <strong>{{ this.tableFooter.pa_adjust.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</strong>
                            </span>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="text-right d-block">
                    <gofix-button label="CANCEL" @click="modalsAdjust.edit.open = false" noBorder></gofix-button>
                    <gofix-button label="SAVE" :loading="modalsAdjust.edit.loading" @click="saveDrafDataEntry" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
    </gofix-card>
</template>
<script>
import moment from 'moment';
export default {
    name: 'consolidated-report-per-location',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'table-consolidated-report-per-location',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: { },
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'assessment_type',
                        label: 'Assessment Type',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-left',
                        tdClass: 'text-left',
                        thStyle:'width: 350px',
                    },
                    {
                        key: 'weightage',
                        label: 'Weightage',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right',
                        thStyle:'width: 215px',
                    },
                    {
                        key: 'actual_score',
                        label: 'Actual Score',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-right',
                        tdClass: 'text-right',
                        thStyle:'width: 375px',
                    },
                    {
                        key: 'auto',
                        label: '',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            supplier_contract: '',
            locations: [],
            location: '',
            property_types: ['Residential', 'Hawker Centre'],
            property_type: 'Residential',
            years: [],
            year: '',
            months: [],
            month: '',
            timer: {
                location: null,
                scontract: null
            },
            activeExportBtn: false,
            tableFooter: {
                deduction: 0,
                percent_payment_to_contractor: 0,
                payment_to_contractor: 0,
                total_actual_score: 0,
                total_weight: 0,
                adjust: 0,
                pa_adjust: null,
                gst: 0,
                payment_to_gst: 0,
                contract_sum_after_gst: 0,
                cv_assessment_ld: 0,
                additional_ld: 0,
                final_payment_to_contractor: 0,
                contract_sum: 0,
            },
            modalsAdjust: {
                edit : {
                    open: false,
                    loading: false,
                    title: "Adjust Score",
                    data: {
                        adjust: null,
                        final_score: null
                    },
                }
            },
        }
    },
    watch: {
        ClientContractID: function(val) {
            this.getSupplierContract(null, true);
        },
        "supplier_contract": function(val) {
            this.location = null
            this.searchLocation('', () => {})
        },
        "location": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "property_type": function(val) {
            this.location = null
            this.searchLocation('', () => {})
            this.$refs.gofixTable.reloadTableItems();
        },
        "month": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "year": function(val) {
            this.$refs.gofixTable.reloadTableItems();
        },
        "modalsAdjust.edit.data.final_score" : function(val) {
            let value = 0;
            if(val) value = Number(val);
            this.modalsAdjust.edit.data.adjust = (value - this.tableFooter.total_actual_score).toFixed(2);
        }
    },
    created() {
        this.getInitData()
        this.getSupplierContract(null, true);
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            this.tableFooter.deduction = 0;
            this.tableFooter.percent_payment_to_contractor = 0;
            this.tableFooter.payment_to_contractor = 0;
            this.tableFooter.total_actual_score = 0;
            this.tableFooter.total_weight = 0;
            this.tableFooter.adjust = 0;
            this.tableFooter.pa_adjust = null;
            this.tableFooter.gst = 0;
            this.tableFooter.payment_to_gst = 0;
            this.tableFooter.contract_sum_after_gst = 0;
            this.tableFooter.cv_assessment_ld = 0;
            this.tableFooter.additional_ld = 0;
            this.tableFooter.final_payment_to_contractor = 0;
            this.tableFooter.contract_sum = 0;
            
            if ( !this.supplier_contract || !this.location ) {
                this.activeExportBtn = false
                const response = {
                    items: [],
                    total: 0
                }
                resolve(response);
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                return;
            }

            tableRequest.month = this.month
            tableRequest.year = this.year
            tableRequest.contract_id = this.supplier_contract.id
            tableRequest.property_id = this.location.location_id
            tableRequest.property_type = this.property_type
            tableRequest.type = 'interim report per location'

            await this.$store.dispatch("PAConservancyController/getPAReport", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                this.tableFooter.deduction = response.deduction || 0;
                this.tableFooter.percent_payment_to_contractor = response.percent_payment_to_contractor || 0;
                this.tableFooter.payment_to_contractor = response.payment_to_contractor || 0;
                this.tableFooter.total_actual_score = response.total_actual_score || 0;
                this.tableFooter.total_weight = response.total_weight || 0;
                this.tableFooter.less_rates_of_deduction = response.less_rates_of_deduction || 0;
                this.tableFooter.adjust = Number(response.adjust) || 0;
                this.tableFooter.pa_adjust = response.pa_adjust || null;
                this.tableFooter.gst = response.gst || 0;
                this.tableFooter.payment_to_gst = response.payment_to_gst || 0;
                this.tableFooter.contract_sum_after_gst = response.contract_sum_after_gst || 0;
                this.tableFooter.cv_assessment_ld = response.cv_assessment_ld || 0;
                this.tableFooter.additional_ld = response.less_rates_of_deduction || 0;
                this.tableFooter.final_payment_to_contractor = response.final_payment_to_contractor || 0;
                this.tableFooter.contract_sum = response.contract_sum || 0;
                resolve(response);

                if(this.tableConfig.total != 0){
                    this.activeExportBtn = true
                }else{
                    this.activeExportBtn = false
                }
            })
            .catch(err => { })
        },
        getInitData(){
            this.loadingData = true;
            var iYear = parseInt(moment().format('YYYY'));
            if(this.Year) this.year = this.Year;
            else this.year = iYear;
            
            for(var i=0;i<15;i++){
                this.years.push(iYear);
                iYear--;
            }
            this.month = moment().format('MM');
            this.populateMonthHeaders();
        },
        populateMonthHeaders(){
            var mTime = moment(this.year+"-"+"January"+"-"+"01","YYYY-MMMM-DD");
            var iMonth = 0;
            var iMonths = [];
            while(iMonth<12){
                var dTime = mTime.clone();
                dTime.add(iMonth,'month');
                iMonths.push({'text' : dTime.format('MMMM'), 'value' : dTime.format('MM')});
                iMonth++;
            }
            this.months = iMonths;
        },
        async getSupplierContract(search = null, is_set_default = false) {
            this.loading = true
            let tableRequest = {
                filter: {
                    contract_title: { type: "text", value: search, function: "ilike", with: [] },
                    contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                },
                limit: 100,
                page: 1,
                isCMS: 1,
                useDatabaseView: true,
                sortColumn: "contract_title",
                sortDirection: "ASC"
            }
            await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
            .then(response => {
                this.supplier_contracts = response.data.data.contracts
                if(is_set_default) {
                    this.supplier_contract = null
                    if(response.data.data.contracts[0]){
                        this.supplier_contract = response.data.data.contracts[0]
                    }
                }
                
                this.loading = false
            })
            .catch(err => {
                this.loading = false
            })
        },
        searchSupplierContract(search, loading){
            loading(true);
            this.supplier_contracts = []
            if(this.timer.scontract) {
                clearTimeout(this.timer.scontract);
                this.timer.scontract = null;
            }
            this.timer.scontract = setTimeout(async () => {
                try {
                    await this.getSupplierContract(search);
                    await loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        searchLocation(search, loading) {
            this.loading = true
            this.locations = []
            if (this.timer.location) {
                clearTimeout(this.timer.location);
                this.timer.location = null;
            }
            this.timer.location = setTimeout(() => {
                this.key_search_property = search;
                const property_root_id = this.supplier_contract ? this.supplier_contract.property_root_id : null
                const contract_id = this.supplier_contract ? this.supplier_contract.id : null

                // this.$store.dispatch('PropertyController/getSearchProperties', {
                //     keyword: search,
                //     property_root_id: property_root_id,
                //     limit: 100,
                //     is_active: true,
                //     property_type: this.property_type,
                //     contract_id: contract_id,
                // })
                this.$store.dispatch('PerformanceAssesmentSettingsController/getItems', {
                    keyword: search,
                    property_root_id: property_root_id,
                    type_setting: 'pa_contract_sum_setting',
                    filter: {
                        contract_id: contract_id,
                        property_type: this.property_type,
                        location_name: ''
                    },
                    sortColumn: 'location_name',
                    sortDirection: 'asc',
                })
                .then(response => {
                    this.locations = response.items
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
            }, 500);
        },
        async dataPAReport() {
            if ( !this.supplier_contract ) {
                return false;
            }
            if ( !this.location ) {
                return false;
            }

            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_id: this.location.location_id,
                property_type: this.property_type,
                type: 'interim report per location'
            };

            await this.$store.dispatch("PAConservancyController/getPAReport", getParam)
            .then(response => {
                this.tableItems = response.items
            })
            .catch(err => { })
        },
        async exportReport() {
            let getParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_id: this.location.location_id,
                property_type: this.property_type,
                type: 'interim report per location',
                is_download_pdf: true,
            };

            await this.$store.dispatch("PAConservancyController/exportPAReport", getParam)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'consolidated-report-per-location-' + this.month + '-' + this.year + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
        async exportExcel() {
            
            let getNewParam = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                property_id: this.location.location_id,
            };

            await this.$store.dispatch("PAConservancyController/exportInterimReportPerLocationExcel", getNewParam)
            .then(response => {
                let nameFile = 'Consolidated_Report_Per_Location.xlsx';
                if(response.headers["content-disposition"]) {
                  let arrTemp = response.headers["content-disposition"].split("filename=");
                  if(arrTemp[1]) {
                    nameFile = arrTemp[1].replaceAll('"', "");
                  }
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => { })
        },
        openModalEdit(){
            this.modalsAdjust.edit.data.adjust = this.tableFooter.adjust || null
            let final_score = this.tableFooter.total_actual_score;
            if(this.modalsAdjust.edit.data.adjust) final_score = this.tableFooter.total_actual_score + this.modalsAdjust.edit.data.adjust
            this.modalsAdjust.edit.data.final_score = final_score;
            this.modalsAdjust.edit.open = true
        },
        saveDrafDataEntry(){
            let adjust = parseInt(this.modalsAdjust.edit.data.adjust)

            if ( !adjust ) {
                adjust = 0;
            }
            if ( adjust > 100 ) {
                return this.$alertNotification("Total Adjust must be less than or equal to 100%", "danger")
            }

            this.modalsAdjust.edit.loading = true;
            let dataSave = {
                month: this.month,
                year: this.year,
                contract_id: this.supplier_contract.id,
                property_type: this.property_type,
                items: [
                    {
                        property_id: this.location.location_id,
                        adjust: this.modalsAdjust.edit.data.adjust
                    }
                ]
            }

            this.$store.dispatch("PAConservancyController/saveInterimReport", dataSave)
            .then(response => {
                this.$alertNotification("Successfully updated final report", "success");
                this.modalsAdjust.edit.loading = false;
                this.modalsAdjust.edit.open = false;
                this.$refs.gofixTable.reloadTableItems();
            })
            .catch(err => {
                this.modalsAdjust.edit.loading = false;
                if (err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "danger")
                }
            })
        },
    }
}
</script>